'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvQueueMusic = function AvQueueMusic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z' })
  );
};
AvQueueMusic = (0, _pure2.default)(AvQueueMusic);
AvQueueMusic.displayName = 'AvQueueMusic';
AvQueueMusic.muiName = 'SvgIcon';

exports.default = AvQueueMusic;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/av/queue-music.js
// module id = 1153
// module chunks = 0